import { render, staticRenderFns } from "./CargoVehicleEntriesFilters.vue?vue&type=template&id=38777ce2"
import script from "./CargoVehicleEntriesFilters.vue?vue&type=script&lang=js"
export * from "./CargoVehicleEntriesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports